import { MenuButton as FluentMenuButton, makeStyles, MenuButtonProps, mergeClasses } from '@fluentui/react-components';
import { forwardRef } from 'react';
import { STATUS_BLUE } from '../constants/colors.constants';

const useStyles = makeStyles({
  root: {
    '& .fui-MenuButton__menuIcon': {
      fontSize: '15px',
      marginBottom: '6px',
      rotate: '90',
    },
  },
  blueAccent: {
    backgroundColor: STATUS_BLUE,
    '&:hover': {
      backgroundColor: '#18599b',
    },
    '&:hover:active': {
      backgroundColor: '#193253',
    },
  },
});

type TProps = MenuButtonProps & {
  variant?: 'default' | 'blue';
};

export const MenuButton = forwardRef<HTMLButtonElement, TProps>((props, ref) => {
  const classes = useStyles();

  const { variant, className } = props;

  const classNames = [classes.root];
  if (variant === 'blue') classNames.push(classes.blueAccent);
  if (className) classNames.push(className);

  return <FluentMenuButton {...props} ref={ref} className={mergeClasses(...classNames)} />;
});
